import { render } from "./QrcodeStream.vue?vue&type=template&id=54735a46&scoped=true&lang=html"
import script from "./QrcodeStream.vue?vue&type=script&lang=js"
export * from "./QrcodeStream.vue?vue&type=script&lang=js"

import "./QrcodeStream.vue?vue&type=style&index=0&id=54735a46&lang=css&scoped=true"

import exportComponent from "/Users/aaronmartin/ztzn/vue-qrcode-reader/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54735a46"]])

export default __exports__